import { CanActivate, CanActivateFn ,Router } from '@angular/router';
import { SessionService } from '../services/session-service';
import { Auth } from '../services/auth';
import { take, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';


export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(Auth);
  const sessionService = inject(SessionService);

  const session = sessionService.getSession();
  if (session) {
    return true;
  }

  // Fallback: check the AuthService observable once.
  return authService.isAuthenticated$().pipe(
    take(1),
    map(isAuthenticated => {
      if (isAuthenticated) {
        // Create a short-lived session so subsequent checks use the session.
        try {
          sessionService.setSessionWithTTL({ authenticated: true }, 3600);
        } catch (e) { /* ignore */ }
        return true;
      }
      router.navigate(['/login'],{replaceUrl:true});
      return false;
    })
  );

};
